// extracted by mini-css-extract-plugin
module.exports = {"trailer":"Bf","imgWrapper":"Bh","thumbnail":"Bi","isRental":"Bj","playWrapper":"Bk","playImg":"Bl","title":"Bm","iconWrapper":"Bn","icon":"Bo"};